<template>
  <div class="p-4">
    <h1 class="text-center">فاکتور شماره {{ factor.factoR_ID }}</h1>
    <hr class="border-theme-500 my-4" />

    <!--    Factor Detail -->
    <div class="border rounded-lg p-2 bg-gray-50 text-xs shadow-md">
      <div class="grid grid-cols-2 gap-y-4">
        <div class="flex">
          <font-awesome-icon
            icon="location-dot"
            class="h-4 w-4 text-ColorNerkh"
          />
          <span class="mr-2">
            مکان:
            {{ factor.saloonName }}
          </span>
        </div>

        <div class="flex">
          <font-awesome-icon icon="table" class="h-4 w-4 text-ColorNerkh" />
          <span class="mr-2">
            میز:
            {{ factor.desK_NUMBER }}
          </span>
        </div>

        <div class="flex">
          <font-awesome-icon icon="users" class="h-4 w-4 text-ColorNerkh" />
          <span class="mr-2">
            تعداد:
            {{ factor.tedad }}
            نفر
          </span>
        </div>

        <div class="flex">
          <font-awesome-icon icon="clock" class="h-4 w-4 text-ColorNerkh" />
          <span class="mr-2">
            تاریخ:
            {{ factor.timE_FACTOR + " " + factor.datE_FACTOR }}
          </span>
        </div>
      </div>
      <div class="flex mt-4">
        <font-awesome-icon
          icon="file-signature"
          class="h-4 w-4 text-ColorNerkh"
        />
        <span class="mr-2">
          توضیحات:
          {{ factor.description }}
        </span>
      </div>
    </div>

    <!--    Payment Status -->
    <div class="flex justify-between bg-gray-100 p-4 rounded-lg mt-4">
      <span class="">مبلغ قابل پرداخت:</span>
      <div class="text-center">
        <span class="text-ColorNerkh font-bold">{{
          $helper.priceFormatter(this.totalPrice / 10)
        }}</span>
        <br />
        <span class="text-xs" :class="renderPaymentType()"
          >({{ factor.pardakhT_STATUS }})</span
        >
      </div>
    </div>
    <hr class="border-theme-500 my-2" />
    <!--    Status -->
    <h1 class="mt-4">وضعیت غذا</h1>

    <h1 class="text-xs text-gray-700 mt-2" v-if="factor.iranI_STATUS_CODE > -2">
      ایرانی
    </h1>
    <div
      class="flex text-xs gap-2 mt-1 text-center"
      v-if="factor.iranI_STATUS_CODE > -2"
    >
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.iranI_STATUS_CODE >= -1 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        در انتظار
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -top-5 right-6"
          v-if="factor.iranI_STATUS_CODE === -1"
        />
      </span>
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.iranI_STATUS_CODE >= 0 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        در صف
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -top-5 right-4"
          v-if="factor.iranI_STATUS_CODE === 0"
        />
      </span>
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.iranI_STATUS_CODE >= 1 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        آماده سازی
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -top-5 right-6"
          v-if="factor.iranI_STATUS_CODE === 1"
        />
      </span>
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.iranI_STATUS_CODE >= 2 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        آماده تحویل
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -top-5 right-6"
          v-if="factor.iranI_STATUS_CODE === 2"
        />
      </span>
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.iranI_STATUS_CODE >= 3 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        تحویل شده
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -top-5 right-6"
          v-if="factor.iranI_STATUS_CODE === 3"
        />
      </span>
    </div>

    <h1
      class="text-xs text-gray-700 mt-4"
      v-if="factor.farangI_STATUS_Code > -2"
    >
      فست فود
    </h1>
    <div
      class="flex text-xs gap-2 mt-1 text-center"
      v-if="factor.farangI_STATUS_Code > -2"
    >
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.farangI_STATUS_Code >= -1 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        در انتظار
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -bottom-5 right-6"
          v-if="factor.farangI_STATUS_Code === -1"
        />
      </span>
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.farangI_STATUS_Code >= 0 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        در صف
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -bottom-5 right-4"
          v-if="factor.farangI_STATUS_Code === 0"
        />
      </span>
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.farangI_STATUS_Code >= 1 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        آماده سازی
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -bottom-5 right-6"
          v-if="factor.farangI_STATUS_Code === 1"
        />
      </span>
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.farangI_STATUS_Code >= 2 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        آماده تحویل
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -bottom-5 right-6"
          v-if="factor.farangI_STATUS_Code === 2"
        />
      </span>
      <span
        class="relative border p-1.5 rounded-lg"
        :class="
          factor.farangI_STATUS_Code >= 3 ? 'bg-ColorNerkh' : 'border-theme-500'
        "
      >
        تحویل شده
        <font-awesome-icon
          icon="arrow-turn-up"
          class="h-5 w-5 absolute text-red-500 -bottom-5 right-6"
          v-if="factor.farangI_STATUS_Code === 3"
        />
      </span>
    </div>

    <!--    Foods -->
    <h1 class="mt-4">غذا ها</h1>
    <FactorFoodCard
      v-for="food in factor.goods"
      :key="food.kala"
      :food="food"
    />

    <div
      class="w-full mt-4 flex text-sm"
      v-if="factor.pardakhT_STATUS_CODE === 0"
    >
      <VButton class="w-full border bg-green-700 text-white shadow-md" @click="pay" :loading="loading">
        پرداخت آنلاین
      </VButton>

      <VButton class="w-full mr-4 border bg-BgButton text-white shadow-md" @click="callWaiter" :loading="loading">
        درخواست کارتخوان
      </VButton>
    </div>

    <div class="h-10"></div>
  </div>

  <div
    class="fixed flex items-center justify-center top-0 w-full h-full bg-gray-500/50"
    v-if="loading"
  >
    <LoadingSpinner class="w-10 h-10 text-ColorNerkh" />
  </div>
</template>

<script>
import {
  callWaiter,
  getFactorDetail,
  payFactor,
  getFinalFactor,
} from "@/API/API";
import FactorFoodCard from "@/components/User/FactorFoodCard";
import LoadingSpinner from "@/components/General/LoadingSpinner";
import VButton from "@/components/General/VButton";

export default {
  name: "FactorDetail",
  components: {
    VButton,
    LoadingSpinner,
    FactorFoodCard,
  },
  data() {
    return {
      factor: {},
      loading: true,
      totalPrice: "",
    };
  },
  async created() {
    this.factor = (await getFactorDetail(this.$route.params.id)).data.result;
    this.loading = false;
    this.getFactoSum();
  },
  // computed: {
  //   totalPrice() {
  //     return this.$store.state.factorSum.paymentAfterTax;
  //   },
  // },
  methods: {
    renderPaymentType() {
      switch (this.factor.pardakhT_TYPE) {
        case "NoPaid":
          return "text-red-500";
        case "Paid":
          return "text-green-500";
        case "Remain":
          return "text-yellow-500";
      }
    },
    pay() {
      this.loading = true;
      payFactor(this.factor.factoR_ID).then((resp) => {
        window.location.href = resp.data.result;
      });
    },
    callWaiter() {
      this.loading = true;
      callWaiter(this.factor.desK_NUMBER, " درخواست دستگاه پوز دارد")
        .then((resp) => {
          this.$swal({
            icon: "success",
            title: "موفق",
            text: resp.data.result,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFactoSum() {
      getFinalFactor(this.factor).then((resp) => {
        this.totalPrice = resp.data.result.factorSum.paymentAfterTax;
      });
    },
  },
};
</script>

<style scoped></style>
